import { useState, useEffect } from 'react';

export const useForm = (initialData, validateFn) => {
    const [formData, setFormData] = useState(initialData);
    const [error, setError] = useState('');

    useEffect(() => {
        setFormData(initialData);
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const result = validateFn(formData);
        if (!result.valid) setError(result.error);
        else setError('');
        return result.valid;
    };

    return { formData, setFormData, error, setError, handleChange, validate };
};
